import React from "react";
import { useState } from "react";
import { useEffect } from "react";

const Calendly = ({ url }) => {
  const [loaded, setLoaded] = useState(false);
  const clientUrl = url ? (
    url.includes("https://calendly.com/") ? url : `https://calendly.com/${url}`
  ) : null;

  useEffect(() => {
    if (!url) return;
    const scriptUrl = "https://assets.calendly.com/assets/external/widget.js";
    const scriptTag = document.createElement("script");
    scriptTag.setAttribute("src", scriptUrl);
    scriptTag.onload = setLoaded(true);
    document.body.appendChild(scriptTag);

    return () => {
      document.querySelector(`script[src*="${scriptUrl}"]`).remove();
    };
  }, [url]);

  return(
    loaded && url && (
      <div
        className="calendly-inline-widget"
        data-url={`${clientUrl}?hide_landing_page_details=1`}
        style={{ minWidth: 320, height: 630 }}
      />
    )
  );
};

export default Calendly;
